import Behaviour, { mix, DomEvents } from '@/core'
import { Route } from '@/core/router'
import resizer from 'spon-resize'
import debounce from 'lodash.debounce'
import setStyle from '@/utils/setStyle'
import SponLax from 'sponlax'

export default class BgSwitch extends mix(Behaviour).with(Route, DomEvents) {
	constructor(el) {
		super(el)

		this.resizer = resizer()
		this.resizer.start()
		this.$container = document.getElementById('related-image-container')
		this.$related = document.getElementById('related-image-base')

		this.images = [...this.$el.querySelectorAll('[data-related-image]')]

		this.$previous = null

		this.resizer.at('(min-width: 48em)', {
			match: () => {
				this.addDomEvents()

				new SponLax('#related-image-container', {
					shouldUnObserve: () => true,
					onEnter: () => {
						this.images.forEach(node => {
							const { src, srcset } = node.dataset
							node.setAttribute('src', src)
							node.setAttribute('srcset', srcset)
						})
					}
				})
			},

			unmatch: () => {
				this.removeDomEvents()
			}
		})
	}

	onChange = () => {
		this.removeDomEvents()
	}

	events = {
		'mouseenter [data-image]': debounce((e, elm) => {
			if (this.$previous) {
				setStyle(this.$previous, {
					opacity: 0
				})
			}

			this.$container.classList.add('bg-black')

			const { index } = elm.dataset
			const node = this.images[index]
			setStyle(node, {
				opacity: 0.5
			})

			this.$previous = node
		}, 100)
	}
}
